import { createFileRoute, redirect } from "@tanstack/react-router"

import { useAuthStore } from "@/stores/authStore"

export const Route = createFileRoute("/admin/orgs")({
  beforeLoad: () => {
    const hasFullAdmin = useAuthStore
      .getState()
      .hasPermission("view:full_admin_panel")
    if (hasFullAdmin) return

    const apps: string[] = JSON.parse(localStorage.getItem("apps") || "[]")
    if (!apps.includes("map")) {
      throw redirect({ to: "/admin" })
    }
  },
})
